import { render, staticRenderFns } from "./NewComposerFacebook.vue?vue&type=template&id=16da5e3a&"
import script from "./NewComposerFacebook.vue?vue&type=script&lang=js&"
export * from "./NewComposerFacebook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports